/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {supportPhoneStatus} from '../api'

 export const useQuerySupportPhoneStatus = createReactQueryHook('supportPhoneStatus', supportPhoneStatus)
